<app-menu-common url="sales"></app-menu-common>

@if (formGroup) {
  <!-- <div class="pageheader flexcolumn" [formGroup] = "formGroup">
  <section class="flexrow">
    <div *ngIf="!formGroup.get('has_variants')?.value" class="grey pagetitle"><span *ngIf="template_id == 0">Nouveau&nbsp;</span>Modèle Produit&nbsp;{{formGroup.get("name")?.value}}</div>
    <div *ngIf="formGroup.get('has_variants')?.value" class="grey pagetitle">Modèle Produit&nbsp;générique&nbsp;{{formGroup.get("name")?.value}}</div>
    <span class="spacer"></span>
    <div *ngIf="template_id !==0" class="grey pagetitle">#&nbsp;{{template_id}}</div>
    <div *ngIf="template_id ==0" class="init">En création</div>
  </section>
</div> -->
<app-action-bar form="mainform" (submitEmitter)="onSubmit($event)">
  @if (formGroup.value.has_variants) {
    <app-variants-button [id]="template_id"></app-variants-button>
  }
  @if (!formGroup?.value.has_variants) {
    <app-product-button [template_id]="template_id" [id]="formGroup.value.unique_variant"></app-product-button>
  }
</app-action-bar>
<div class="pagecontent " >
  <!-- En création, l'écran DIT ce qu'il va créer : le sélecteur de produits y mène par deux
       boutons, et le même formulaire donne un produit à plat ou un modèle générique. -->
  @if (template_id === 0) {
    <div class="creation-banner" [class.generic]="creationKind === 'generic'">
      <mat-icon>{{ creationKind === 'flat' ? 'inventory_2' : 'category' }}</mat-icon>
      @if (creationKind === 'flat') {
        <span><b>Nouveau produit (à plat)</b>&nbsp;— le modèle et son unique produit sont créés ensemble&nbsp;; « Enregistrer » ouvre ensuite la fiche du produit, où se saisissent prix, conditionnements et références.</span>
      } @else {
        <span><b>Nouveau modèle générique</b>&nbsp;— le produit générique seul&nbsp;; ses déclinaisons se déclarent ensuite par les attributs.</span>
      }
    </div>
  }
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit($event)" id="mainform">
    <div class="maincontent template" >
      <app-product-tpl-general  [canEditGeneral]="true" [attachs_images]="attachs_images"  ></app-product-tpl-general>
      <!-- <app-product-tpl-general [is_flatProduct]="false" [canEditGeneral]="true" [attachs_images]="attachs_images" (supplierAdd)="addSupplier($event)"  (supplierRemove)="removeSupplier($event)"  ></app-product-tpl-general> -->
      <!-- <app-general></app-general> -->
      <app-attributes (updateProductAttributes)="updateProductAttributes($event)" [loadProductTplEventsSubject$]="loadProductTplEventsSubject.asObservable()"   ></app-attributes>
      <mat-tab-group [selectedIndex]="0">
        <mat-tab label="Documents" [disabled]="template_id == 0 ? 'true' : null">
          <div class="header_document">
            <input #fileInput type="file" hidden (change)="onFileSelected($event)">
            <button type="button" id="upload-button"  class="custom-filled-button" (click)="fileInput.click()" aria-label="uploader un fichier">
              <mat-icon>upload</mat-icon> Ajoutez un fichier
            </button>
            <smart-input  width="350px" autofocus initialValue="" placeholder="Upload Vidéo Youtube" icon="upload" iconClass="custom-icon-button primary"  (enterPressed)="uploadYoutubeVideo($event)"  (iconClicked)="uploadYoutubeVideo($event)"  />
          </div>
          <app-image-carousel [attachs]="attachs_images" />
        </mat-tab>
        @if (true) {
          <mat-tab label="Spécifiques">
            <div class="maincontent specific">
              <div>
                <app-tree-node-decl  (updateProductAttributeValues)="updateProductAttributeValues($event)"   [loadProductTplEventsSubject$]="loadProductTplEventsSubject.asObservable()"  ></app-tree-node-decl >
              </div>
            </div>
          </mat-tab>
        }
        <mat-tab label="Fournisseurs" [disabled]="template_id == 0 ? 'true' : null">
          <div class="supplier-wrapper flexcolumn">
            <app-search-partner id="search-fab" width="300px"   [roles]="[ROLE_MANUFACTURER]"></app-search-partner>
            @for (supplier of formGroup.value.lnk_suppliers ; track supplier; let i = $index) {
              <div class="flexrow" style="align-items: center;">
                <button class="custom-icon-button error"    ><mat-icon>delete</mat-icon></button>
                <a mat-button  (click)="openPartnerDialog(supplier.id)"  >{{ supplier.name }}</a>
                <!-- <span   >{{ supplier.name }}</span> -->
              </div>
            }
          </div>
        </mat-tab>
        <mat-tab label="Arborescence" [disabled]="template_id == 0 ? 'true' : null">
          <div class="tree-wrapper flexrow">
            <ul class="root-ul">
              @if ((tree?.children?.length ?? 0) > 0) {
                <app-tree    [tree]="tree.children[0]"   [selected]="selectedTreeNode"   (selectedChangeEmitter)="onSelectedChange($event)" ></app-tree>
              }
            </ul>
          </div>
        </mat-tab>
      </mat-tab-group>
      <app-cuf [cufsStructure]="cufsStructure"   [cufGroup]="getCufGroupe()" ></app-cuf>
    </div>
  </form>
</div>
}
